import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { TransformationSection } from './components/TransformationSection';
import { AudienceSection } from './components/AudienceSection';
import { SystemSection } from './components/SystemSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BenefitsSection } from './components/BenefitsSection';
import { CareerSection } from './components/CareerSection';
import { CertificateSection } from './components/CertificateSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { WhatsAppButton } from './components/WhatsAppButton';
import { initPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen bg-[#f9f4e8] text-[#1e3a1e]" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <TransformationSection data-id="element-3" />
        <AudienceSection data-id="element-4" />
        <SystemSection data-id="element-5" />
        <PreviewCarousel data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <CareerSection data-id="element-8" />
        <CertificateSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTASection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
      <WhatsAppButton data-id="element-16" />
    </div>;
}